import React, { useEffect, useState } from 'react';
import ListOfDisponserList from './components/ListOfDisponserList';
import { getDispensaryData } from "../../services/dispansery";
import { Button, Input } from "antd";
import { useTranslation } from 'react-i18next';
import { DataTable, PageCard, PageShell, PageToolbar } from "../../components/ui";

const ListOfDisponser = () => {
    const { t } = useTranslation();
    const [dispensaryData, setDispensaryData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Number of items per page

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await getDispensaryData();
                setDispensaryData(data.data);
            } catch (error) {
                console.error('Ошибка при получении данных о диспансере:', error);
            }
        };

        fetchData();
    }, []);

    // Calculate current items to display based on currentPage and itemsPerPage
    const startIndex = (currentPage - 1) * itemsPerPage;
    const currentItems = dispensaryData.slice(startIndex, startIndex + itemsPerPage);

    // Handle page change
    const handlePreviousPage = () => {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
    };

    const handleNextPage = () => {
        setCurrentPage((prevPage) => Math.min(prevPage + 1, Math.ceil(dispensaryData.length / itemsPerPage)));
    };

    const columns = [
        {
            title: t('common.name'),
            key: "name",
            render: (_, record) => (
                <span className="block text-sm font-medium text-[#1D2C7B] min-w-[150px]">{record.patient.name}</span>
            ),
        },
        {
            title: t('patients.birthDate'),
            key: "date",
            width: 160,
            render: (_, record) => (
                <span className="text-sm text-slate-700 tabular-nums whitespace-nowrap">{record.visit.date}</span>
            ),
        },
        {
            title: t('common.phone'),
            key: "phone",
            width: 180,
            render: (_, record) => (
                <a
                    href={`tel:+${record.patient.phone}`}
                    className="text-sm text-[#1D2C7B] tabular-nums whitespace-nowrap"
                >
                    {record.patient.phone}
                </a>
            ),
        },
        {
            title: t('common.identifier'),
            key: "user",
            render: (_, record) => <span className="text-sm text-slate-700">{record.user_id.name}</span>,
        },
        {
            title: t('common.visitDay'),
            key: "service",
            width: 140,
            render: (_, record) => (
                <span className="text-sm text-slate-700 tabular-nums">{record.service.id}</span>
            ),
        },
    ];

    const renderMobileCard = (record) => (
        <div>
            <span className="block text-sm font-semibold text-[#1D2C7B] truncate">{record.patient.name}</span>
            <span className="block text-xs text-slate-500 mt-0.5 truncate">{record.user_id.name}</span>

            <div className="mt-2.5 flex flex-wrap items-center gap-x-3 gap-y-1.5 text-xs text-slate-600">
                <span className="tabular-nums">{record.visit.date}</span>
                <a href={`tel:+${record.patient.phone}`} className="tabular-nums text-[#1D2C7B]">
                    {record.patient.phone}
                </a>
            </div>
        </div>
    );

    return (
        <PageShell>
            <PageCard>
                <PageToolbar
                    title={t('admissions.dispensary')}
                    count={dispensaryData.length}
                    filters={
                        <>
                            <ListOfDisponserList/>
                            <Input.Search
                                placeholder={t('common.search')}
                                allowClear
                                size="small"
                                className="md:!w-[220px]"
                            />
                        </>
                    }
                />

                <DataTable
                    columns={columns}
                    dataSource={currentItems}
                    mobileCard={renderMobileCard}
                    rowKey={(record) => record.patient.id}
                    scrollX={960}
                    pagination={false}
                />

                <div className="flex flex-wrap items-center justify-between gap-2 border-t border-slate-100 px-2.5 sm:px-3 py-2.5">
                    <span className="text-xs text-slate-500 tabular-nums">
                        {t('common.pageOf', { current: currentPage, total: Math.ceil(dispensaryData.length / itemsPerPage) || 1 })}
                    </span>
                    <div className="flex gap-2">
                        <Button size="small" disabled={currentPage === 1} onClick={handlePreviousPage}>
                            {t('common.prev')}
                        </Button>
                        <Button size="small" disabled={currentPage === Math.ceil(dispensaryData.length / itemsPerPage)} onClick={handleNextPage}>
                            {t('common.next')}
                        </Button>
                    </div>
                </div>
            </PageCard>
        </PageShell>
    );
};

export default ListOfDisponser;
